export default __webpack_public_path__ + "img/50.8d85da.png";